module.exports = __webpack_public_path__ + "static/media/pending.9db9b1b2.png";